import React, { FunctionComponent } from "react";
import { Login } from "./component";
import { useTranslations } from "$hooks";
import { RoutesBuilder } from "$models/RoutesBuilder";
import { ITranslations } from "./interfaces";
import { useHistory } from "react-router-dom";
import { ApolloError, useMutation } from '@apollo/client';
import { AUTH_GOOGLE } from "$mutations";
import { useSnackbar } from "$hooks/snackbar/useSnackbar";
import { useGoogleLogin } from "@react-oauth/google";

export const LoginContainer: FunctionComponent = () => {
  const translations = useTranslations<ITranslations>("login");

  const history = useHistory();

  const [authGoogle] = useMutation(AUTH_GOOGLE);
  const { enqueueSnackbar } = useSnackbar();

  const handleGoogleLogin = async (credentialResponse: any) => {
    try {
      const { data } = await authGoogle({
        variables: { token: credentialResponse.access_token },
      });
      const appToken = data.authGoogle;
      localStorage.setItem('token', appToken);
      window.location.assign(RoutesBuilder.applicant.myProfile());
    }
    catch (error) {
      if (error instanceof ApolloError && error.graphQLErrors.length > 0) {
        const errorData = error.graphQLErrors[0].extensions?.data

        const type = errorData?.errorType
        if (type === 'GoogleUserNotFoundError') {

          const userName = errorData?.name;
          const userSurname = errorData?.surname;
          const signUpToken = errorData?.signUpToken;

          sessionStorage.setItem("signUpToken", signUpToken);

          history.push(RoutesBuilder.applicant.signUp({ nombre: userName, apellido: userSurname }));
        }
        else if (type === 'BadCredentialsError') {
          enqueueSnackbar("Solo se permite una cuenta fiuba para ingresar.", { variant: "error" });
          return
        }
        else {
          enqueueSnackbar("Error desconocido", { variant: "error" });
          return
        }
      }
    }
  };
  const loginWithGoogle = useGoogleLogin({
    onSuccess: (credentialResponse) => handleGoogleLogin(credentialResponse),
    onError: () => {
      enqueueSnackbar("Error al intentar loguearse con Google", { variant: "error" })
    },
    onNonOAuthError: () => {
      enqueueSnackbar("Error. Revisa la configuracion de ventanas emergentes de tu navegador.", { variant: "error" });
    },
    prompt: 'consent'
  })

  return (
    <Login
      handleGoogleLogin={handleGoogleLogin}
      loginAsCompanyUserLink={RoutesBuilder.company.login()}
      translations={translations}
      loginWithGoogle={loginWithGoogle}
    />
  );
};
